export default __webpack_public_path__ + "static/media/webimg2.217274e9.jpg";